import styled, { css } from "styled-components";

export const Preview3Wrapper = styled.div`
  width: calc(100% - 33px);
  height: calc(100% - 33px);
  position: relative;
  background: url("/image-web/poster/poster3/poster3_back.png") no-repeat center
    center;
  background-size: cover;

  display: flex;
  flex-direction: column;

  padding: 16.5px;
`;

export const Preview3HeaderWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
  position: relative;
`;

export const Preview3Logo = styled.img`
  z-index: 1;
  position: absolute;
  top: 42.4px;
  right: 16.27px;
`;

export const Preview3ImageWrapper = styled.div<{
  topPadding: number;
  rightPadding: number;
}>`
  position: absolute;
  top: ${({ topPadding }) => topPadding}px;
  right: ${({ rightPadding }) => rightPadding}px;
  height: ${({ topPadding }) =>
    topPadding ? `${164 - topPadding}px` : `165px`};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  z-index: 1;
  > img {
    height: 100%;
    object-fit: cover;
  }
`;

export const Preview3HeaderTitle = styled.div<{ color: string }>`
  width: 100%;
  height: 33px;
  color: ${({ color }) => color};
  text-shadow: 0 0 23.866px #6436e7, 0 0 14.32px rgba(255, 255, 255, 0.5);
  font-family: Pretendard;
  font-size: 27.385px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  z-index: 2;
`;

export const Preview3HeaderSubTitle = styled.div<{ color: string }>`
  width: 100%;
  height: 26px;
  color: ${({ color }) => color};
  text-shadow: 0 0 14.32px rgba(255, 255, 255, 0.5), 0 0 23.866px #6436e7;
  font-family: Pretendard;
  font-size: 21.908px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  z-index: 2;
`;

export const Preview3HeaderDateWrapper = styled.div<{ color: string }>`
  margin-top: 5.77px;
  width: 100%;
  height: 26px;
  color: ${({ color }) => color};
  font-family: Pretendard;
  font-size: 21.908px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  z-index: 2;
`;

export const Preview3HeaderPubNameWrapper = styled.div<{ color: string }>`
  width: 100%;
  height: 20px;
  color: ${({ color }) => color};
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  z-index: 2;
`;

export const Preview3HeaderLogo = styled.img`
  margin-top: 5.2px;
  width: 79.965px;
  height: 26.29px;
  object-fit: cover;
`;

export const Preview3BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 16.43px;
  margin-top: 5.48px;
`;

export const Preview3BodyLeftWrapper = styled.div<{ showAddress: boolean }>`
  width: 224.5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ showAddress }) => (showAddress ? "6.43px" : "16.43px")};
`;

export const Preview3InfoWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 162.311px;
  border-radius: 8.763px;
  border: 0.548px solid rgba(23, 185, 255, 0.1);
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(255, 16, 123, 0.4) 0%,
    rgba(255, 4, 8, 0.16) 78.06%
  );

  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview3InfoTitle = styled.div`
  width: calc(100% - 32.862px);
  padding: 5.477px 16.431px;
  color: #fff;
  text-align: center;
  font-family: "Termina Test";
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview3InfoBox = styled.div`
  width: calc(100% - 32.862px);
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 5.477px 16.43px;
  gap: 1.1px;

  background: rgba(0, 0, 0, 0.5);
  white-space: pre-line;

  border-radius: 0 0 8.763px 8.763px;

  p {
    margin: 0;
    padding: 0;
  }
`;

export const Preview3InfoRow = styled.div<{
  fontSize: number;
  isShow: boolean;
}>`
  width: 100%;
  display: flex;
  ${({ isShow }) =>
    !isShow &&
    css`
      display: none;
    `}
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: #fff;
  font-family: "Termina Test";
  font-size: ${({ fontSize }) => fontSize}px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
export const Preview3NoticeWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 195.173px;
  border-radius: 8.763px;
  border: 0.548px solid rgba(23, 185, 255, 0.1);
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(255, 16, 123, 0.4) 0%,
    rgba(255, 4, 8, 0.16) 78.06%
  );

  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview3PrizePoolWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  height: 299.237px;
  display: flex;
  flex-direction: column;
  border-radius: 8.763px;
  border: 0.548px solid rgba(28, 6, 66, 0.8);
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(76, 39, 139, 0.8) 0%,
    rgba(28, 27, 51, 0.8) 78.06%
  );
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview3PrizePoolItem = styled.div<{ fontSize: number }>`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: ${({ fontSize }) => fontSize}px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  // > .top3 {
  //   background: linear-gradient(
  //     95deg,
  //     #d9ff00 0.13%,
  //     #fff 18.47%,
  //     #4bf95f 43.3%
  //   );
  //   background-clip: text;
  //   -webkit-background-clip: text;
  //   -webkit-text-fill-color: transparent;
  // }
`;

export const Preview3BodyRightWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
  showAddress: boolean;
}>`
  flex: 1;
  height: ${({ showAddress }) => (showAddress ? "calc(100% - 20px)" : "100%")};
  display: flex;
  flex-direction: column;

  border-radius: 8.763px;
  border: 0.548px solid #17b9ff;
  background: linear-gradient(180deg, rgba(46, 167, 255, 0.5) 0%, #1c1b33 78%);
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.5);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview3StructureTitle = styled.div`
  width: 100%;
  height: 27.385px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: "Termina Test";
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview3structureHeaderWrapper = styled.div`
  width: calc(100% - 32.86px);
  height: 21.9px;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12.62px;
`;

export const Preview3structureHeaderItem = styled.div<{
  flex: number;
  isShow: boolean;
}>`
  flex: ${({ flex }) => flex};
  ${({ isShow }) =>
    !isShow &&
    css`
      display: none;
    `}
  color: #FFF;
  text-align: center;
  font-family: "Termina Test";
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview3StructureRow = styled.div<{
  hasLine: boolean;
  isFinal: boolean;
}>`
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: row;
  gap: 12.62px;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);

  ${({ isFinal }) =>
    isFinal &&
    css`
      border-radius: 0 0 8.763px 8.763px;
    `}

  ${({ hasLine }) =>
    hasLine &&
    css`
      border-top: 0.548px solid #fff;
    `}
`;
export const Preview3StructureItem = styled.div<{
  flex: number;
  isShow: boolean;
}>`
  flex: ${({ flex }) => flex};
  ${({ isShow }) =>
    !isShow &&
    css`
      display: none;
    `}

  color: #FFF;
  text-align: center;
  font-family: "Termina Test";
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview3StructureBreak = styled.div`
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
  text-align: center;
  font-family: "Termina Test";
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview3AddressWrapper = styled.div`
  position: absolute;
  bottom: 10.43px;
  left: 0;
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: column;

  align-items: center;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 10.954px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
